<template>
    <div class="externallink"
         :style='{"backgroundColor":config.backgroundColor,"backgroundImage":config.backgroundColor}'>
        <Swipe class="swipe" indicator-color="white" width="200px" height="100px">
            <SwipeItem v-for="(item,index) in bannerList" :keys="index">
                <van-image :src="item.imgurl" fit="cover" @click="go(item.jumpurl)"/>
            </SwipeItem>
        </Swipe>
        <div class="body">
            <div class="van-hairline--top-bottom link-item" v-for="(item,index) in links" @click="go(item.jumpurl)">
                <van-image :src="item.imgurl" width="6.9rem" height="2.9rem" fit="cover" style="display:flex;"/>
                <div class="title" :style='{"color":config.titlecolor}'>{{item.title}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import {Image, Swipe, SwipeItem} from 'vant';

    export default {
        name: "enternallink",
        props: ['ec_id'],
        data() {
            return {
                config: {
                    backgroundImage: '',
                    backgroundColor: '',
                    titlecolor: ""
                },
                links: [],
                bannerList: []
            }
        },
        components: {
            VanImage: Image,
            Swipe,
            SwipeItem
        },
        methods: {
            go: function (e) {
                window.location.href = e;
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$api.common.getLinks({id: this.ec_id, expand: 'externallink'}).then((res) => {
                    let {externallink, backgroundimage, backgroundcolor, titlecolor} = res.data;
                    this.links = externallink;
                    this.config = {backgroundImage: backgroundimage, backgroundColor: backgroundcolor, titlecolor}
                })
                this.$api.common.getBanners({position: 13, positionid: 1}).then((res) => {
                    if (+res.status === 200) {
                        this.bannerList = res.data;
                    }
                })

            })
        }
    }
</script>
